import React from "react";
import "./cardsOther.scss";
import classNames from "classnames";
import Image from "../../modules/Image/image.js";
import Icon from "../../elements/Icon/icon.js";
import {Title} from "../../elements/Title/title";
import Column from "../../structure/Column/column";
import {Text} from "../../elements/Text/text";
import {LinkBtn} from "../../elements/LinkBtn/linkBtn";

export const CardsOther = props => {
    const dataCards = props.dataCards;
    const productMeta = props.productMeta;
    const textStatic = props.textStatic;
    const classnames = classNames(`m-cards-other`, {

    });

    return (
        <div className={props.className ? props.className + ` ` + classnames : classnames}>
            <Title className={`marg-b16`} tag={`h2`} size16 content={props.title} />
            <Column row className={`marg-b32`}>
                {dataCards.map((value, key) => (
                    <Column row key={key} className={`m-cards-other--item`}>
                        <Column col="fifth" colSm="third" className={`m-cards-other--img`}>
                            <Image filename={value.image_logo}/>
                        </Column>
                        <Column className={`m-cards-other--info`} row col="fifth-complete" colSm="third-complete">
                            <Column col="full">
                                <p className={'m-cards-other--title'}><span>{value.bank_name}</span> | {value.category_name} {value.short_name}</p>
                            </Column>
                            <Column col="forth" colSm="third" className={"m-cards-other--transmitter"}>
                                {
                                    Object.keys(value.transmitter).map(function(d){
                                        return <Icon className={`marg-r5`} icon={value.transmitter[d]["slug"] + ".png"} height={`25`} />
                                    })
                                }
                            </Column>
                            <Column col="forth" colSm="third" colXs="half">
                                <Text className="m-card-other--text" content={`${value.cost_rate} %`} />
                            </Column>
                            <Column col="forth" colSm="third" colXs="half">
                                <Text className="m-card-other--text" content={`${productMeta.currency_symbol}${value.cost_admin}`} />
                            </Column>
                            <Column col="forth" colSm="full">
                                <LinkBtn alignRight to={`/${value.slug}`} content={`${textStatic.more_info}`} />
                            </Column>
                        </Column>
                    </Column>
                ))}
            </Column>
        </div>
    );
};